// src/serviceWorkerRegistration.js

// This function is responsible for registering the service worker
export function register() {
    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            navigator.serviceWorker
                .register(swUrl)
                .then((registration) => {
                    console.log('Service Worker registered: ', registration);
                })
                .catch((error) => {
                    console.error('Error during service worker registration:', error);
                });
        });
    }
}

// This function is used for un-registering the service worker
export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then((registration) => {
            registration.unregister();
        });
    }
}
